<div [style]="style" #iconElement id="icon"></div>
